// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__0YGq4","section-1":"styles_section-1__Q9oga","content":"styles_content__-Y77K","section-2":"styles_section-2__QgfTy"};